import { createAsyncThunk } from "@reduxjs/toolkit";
import { Organization } from "../types/organization.types";
import "react-toastify/dist/ReactToastify.css";
import { ApiResponse } from "../../../types/api.types";
import axiosClient from "../../../utils/axios";

export const resolveOrganization = createAsyncThunk<
  Organization,
  string,
  { rejectValue: string }
>("organization/resolveOrganization", async (slug, { rejectWithValue }) => {
  try {
    const response =
      await axiosClient.get<ApiResponse<Organization>>("/auth/org");
    return response.data.data;
  } catch (error: any) {
    return rejectWithValue(
      error?.response?.data?.message ?? "Failed to resolve organization",
    );
  }
});
